export default "__VITE_ASSET__DKfRPNWp__"